import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableNumber, nullableString } from '../utils/wire-value-utils';

/**
 * A drone model in the catalog, linked to a manufacturer. Built from the hub's `/admin/drone-models` JSON
 * (hub `data-models/drone-model.ts`). Writable fields the hub didn't send stay `undefined` (an explicit
 * `null` stays `null`). The hub's `isSeeded` flag is not mapped.
 */
export class DroneModel extends Base {
  // Writable via PUT /admin/drone-models/:id (the hub's DRONE_MODEL_WRITABLE)
  modelName?: string | null;
  description?: string | null;
  maxTakeoffWeightLbs?: number | null;
  imageUrl?: string | null;

  /** Set on create only. */
  manufacturerId?: string | null;

  /** Read-only: set only when the hub joins the manufacturer. */
  manufacturerName?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.modelName = nullableString(source['modelName']);
    this.description = nullableString(source['description']);
    this.maxTakeoffWeightLbs = nullableNumber(source['maxTakeoffWeightLbs']);
    this.imageUrl = nullableString(source['imageUrl']);
    this.manufacturerId = nullableString(source['manufacturerId']);
    this.manufacturerName = nullableString(source['manufacturerName']);
  }
}
